const baseContentfulPath = "/v1/contentful";

const buildContentfulPath = (subPath, param) => {
  let path = `${subPath}`;
  if (param && param !== "") path = `${subPath}/${param}`;
  return baseContentfulPath + path;
};

export default {
  menu: () => buildContentfulPath("/menu"),
  templateGroup: (slug) => buildContentfulPath("/template-groups", slug),
  category: (slug) => buildContentfulPath("/categories", slug),
};
